/**
 * Joyee Banner Carousel
 * Crossfade slideshow with autoplay, dot navigation, touch swipe, and progress ring.
 */
(function() {
  document.querySelectorAll('[data-joyee-carousel]').forEach(function(section) {
    var track  = section.querySelector('[data-joyee-carousel-track]');
    var slides = [].slice.call(section.querySelectorAll('[data-joyee-carousel-slide]'));
    var dots   = [].slice.call(section.querySelectorAll('[data-joyee-carousel-dot]'));
    if (!track || slides.length <= 1) return;

    var autoplaySpeed      = (parseInt(section.dataset.autoplaySpeed, 10) || 5) * 1000;
    var transitionDuration = parseInt(section.dataset.transition, 10) || 600;
    // Auto-rotate is on unless the setting explicitly turned it off. When off,
    // the slideshow only advances via dots or swipe.
    var autoplayEnabled    = section.dataset.autoplay !== 'false';
    var totalSlides        = slides.length;
    var currentIndex       = 0;
    var timer              = null;
    var isTransitioning    = false;
    var reducedMotion      = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    section.style.setProperty('--jc-autoplay-duration', autoplaySpeed + 'ms');
    section.setAttribute('data-jc-autoplay', (reducedMotion || !autoplayEnabled) ? 'false' : 'true');
    section.setAttribute('data-jc-paused', 'false');

    var pausedByHover = false;
    var pausedByFocus = false;

    function restartRing() {
      var dot = dots[currentIndex];
      if (!dot) return;
      var c = dot.querySelector('.joyee-carousel__dot-ring circle');
      if (!c) return;
      c.style.animation = 'none';
      void c.offsetWidth;
      c.style.animation = '';
    }

    function goTo(idx) {
      if (idx === currentIndex || isTransitioning) return;
      isTransitioning = true;
      slides[currentIndex].classList.remove('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');
      currentIndex = ((idx % totalSlides) + totalSlides) % totalSlides;
      slides[currentIndex].classList.add('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');
      restartRing();
      setTimeout(function() { isTransitioning = false; }, transitionDuration);
    }

    function next() { goTo(currentIndex + 1); }
    function setPaused() { section.setAttribute('data-jc-paused', (pausedByHover || pausedByFocus) ? 'true' : 'false'); }
    function start() { if (!autoplayEnabled || reducedMotion || pausedByHover || pausedByFocus) return; stop(); timer = setInterval(next, autoplaySpeed); }
    function stop()  { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { goTo(parseInt(dot.dataset.index, 10)); start(); });
    });

    var sx = 0, sy = 0;
    track.addEventListener('touchstart', function(e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    track.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) { dx < 0 ? next() : goTo(currentIndex - 1); start(); }
    }, { passive: true });

    section.addEventListener('mouseenter', function() { pausedByHover = true;  setPaused(); stop(); });
    section.addEventListener('mouseleave', function() { pausedByHover = false; setPaused(); start(); });
    section.addEventListener('focusin',    function() { pausedByFocus = true;  setPaused(); stop(); });
    section.addEventListener('focusout',   function() { pausedByFocus = false; setPaused(); start(); });

    start();
  });
})();